module.exports = __webpack_public_path__ + "img/11.7.Chla.8c51d745.png";